import { request } from './request'
import { IParams } from '@/interface'

/**
 * 模糊搜索
 * @param params
 * @returns
 */
export const remoteSearch = (data: any) => request({
  method: 'post',
  url: '/inputAssociate',
  data
})

/**
 * 获取机器人配置
 * @param data
 * @returns
 */
export const getRobotConfig = (channelId: string) => request({
  method: 'post',
  url: '/getRobotConfig',
  data: { channelId }
})

/**
 * 获取热门意图
 * @param channelId 
 * @param topNum 
 * @returns 
 */
export const getTopHot = (channelId: string, beginTime: string, endTime: string, topNum = 5) => request({
  method: 'post',
  url: '/hotKnowledge',
  data: { 
    channelId,
    beginTime,
    endTime,
    top: topNum
  }
})

export const queryChannelInfo = () => request({
  method: 'post',
  url: '/queryChannelInfo',
  data: {
    channelType: 1
  }
})

export const initConsult = (channelId: any, userId: any) => request({
  method: 'post',
  url: '/initConsult',
  data: {
    channelId,
    userId,
    channel: '1',
    inaction: 8,
    inparams: {},
    isLogin: '2',
    requestType: '',
    userName: '游客'
  }
})

export const sendQuestion = (params: IParams) => request({
  method: 'post',
  url: '/inConsult',
  data: {
    ...params,
    channel: '1',
    inaction: 9,
    isLogin: '2',
    isManMade: '2',
    questionType: '1',
    questionTime: new Date().getTime()
  }
})

/**
 * 保存已解决
 * @param params
 * @returns
 */
export const saveSolved = (params: any) => request({
  method: 'post',
  url: '/saveQuestionnaire',
  data: {
    ...params,
    questionnaire: '',
    channel: '1',
    satisfaction: '1'
  }
})

/**
 * 保存未解决原因
 * @param params
 * @returns
 */
export const saveUnsolvedReason = (params: any) => request({
  method: 'post',
  url: '/saveQuestionnaire',
  data: {
    ...params,
    channel: '1',
    satisfaction: '2'
  }
})

/**
 * 查询不满意原因
 * @param params
 * @returns
 */
export const queryUnSatisList = (channelId: string, knowledgeId: string) => request({
  method: 'post',
  url: '/questionnaire',
  data: {
    channelId,
    knowledgeId
  }
})

/**
 * 查询不满意原因
 * @param params
 * @returns
 */
export const exitConsult = (params: any) => request({
  method: 'post',
  url: '/exitConsult',
  data: {
    ...params,
    channel: '1',
    inaction: 10,
    isLogin: '2'
  }
})

/**
 * 语音转识别结果
 * @param params 
 * @returns 
 */
export const transToText = (params: any) => request({
  method: 'post',
  url: '/trans',
  headers: {
    'Content-Type': 'multipart/form-data'
  },
  data: params,
})

/**
 * 
 * @param params 
 * @returns 
 */
export const audioTts = (params: any) => request({
  method: 'post',
  url: '/common/audioTTS',
  data: params
})

/**
 * 记录转人工
 * @param params 
 * @returns 
 */
export const recordTurnToSeat = (params: any) => request({
  method: 'post',
  url: '/turnToSeat/record',
  data: params
})
